/**
 * Used to automatically save the state of an input element over page reloads
 * Will be applied to any supported element that has the saveMeState class
 */
namespace appn.saveMeState {
    const _namespace: string = 'appn.saveMeState';
    const _page: string = window.location.pathname;
    export let dbKey: string = _namespace + _page;
    let _providerId: number | null = null;
    let _afterChangedCallback: Function | undefined;
    let _onResetCallback: Function | undefined;

    export function init(afterChangedCallback?: Function, onResetCallback?: Function, resetBtnContainerSelector?: string) {
        _afterChangedCallback = afterChangedCallback;
        _onResetCallback = onResetCallback;
        _providerId = $('body').data('providerid');
        dbKey = _namespace + _page + '-' + _providerId;

        // Get all saveMeStates
        const $saveMeStateInputs = $('.saveMeState');
        $saveMeStateInputs.each(function (i, saveMeState) {

            const $saveMeState = $(saveMeState) as JQuery<HTMLInputElement>;

            // update its value to reflect the state in storage
            const pageStateRegister: any = appn.localStorage.getItem(dbKey);

            const registerItem = findItemInRegister(getRegisterId($saveMeState), pageStateRegister);
            if (registerItem)
                setElementValue($saveMeState, (registerItem as any).value);

            // Add on changed to save the state change every time
            const inputType = getInputType($saveMeState);
            if (inputType !== 'button.card-btn-expand-or-collapse' && inputType !== 'appnDateFilter' && inputType !== 'appnTaskTemplateFilter' && inputType !== 'appnFolderFilter' && inputType !== 'appnUserGroupFilter')
                $saveMeState.off().on('change', function () {
                    const valueToSave = getElementValue($(this));
                    const registerId = getRegisterId($(this));
                    const registerItem = {
                        elementId: registerId,
                        value: valueToSave
                    };

                    appn.dataTable.resetPaging();
                    createOrUpdateRegister(registerItem);

                    if (registerItem && registerId && registerId === 'appnDateFilterMini')
                        appn.dateFilterMini.updateActiveOptions(valueToSave);

                    if (_afterChangedCallback)
                        _afterChangedCallback(saveMeState);
                });
            else
                $saveMeState.off().on('click', function (e) {
                    e.preventDefault();

                    let valueToSave = getElementValue($(this) as JQuery<HTMLInputElement>);
                    if (inputType === 'button.card-btn-expand-or-collapse')
                        // Must do opposites here because this is on click so this is the future state.
                        if (valueToSave === 'expanded' || valueToSave === 'collapsed')
                            valueToSave = valueToSave === 'expanded' ? 'collapsed' : 'expanded';

                    const registerItem = {
                        elementId: getRegisterId($(this)),
                        value: valueToSave
                    };

                    appn.dataTable.resetPaging();
                    createOrUpdateRegister(registerItem);

                    if (inputType === 'appnDateFilter' || inputType === 'appnTaskTemplateFilter' || inputType === 'appnFolderFilter' || inputType === 'appnUserGroupFilter')
                        if (_afterChangedCallback)
                            _afterChangedCallback(saveMeState);
                });
        });

        // Append the reset filters button and hook events
        $('.btn-resetFilters').remove();
        if (resetBtnContainerSelector) {
            $(resetBtnContainerSelector).append(appn.dataTable.FILTER_RESET_BTN);

            appn.tooltip.init();

            $('.btn-resetFilters').off().on('click', function () {
                resetState();

                if (_onResetCallback) {
                    $saveMeStateInputs.each(function (_, saveMeState) {
                        const $saveMeState = $(saveMeState);
                        resetInput($saveMeState);
                    });
                    select.init();

                    _onResetCallback();
                } else
                    appn.location.reloadCurrentPage();
            });
        }
    }

    export function getRegisterId($element: JQuery<HTMLElement>) {
        const inputType = getInputType($element);
        let elementId = $element.attr('id');
        if (!elementId)
            if (inputType === 'button.card-btn-expand-or-collapse') {
                // Try get the actual Id
                const $box = $element.closest('.card');
                const connectorIdInput = $box.find('.card-body input[name$=".Id"]');
                let boxId = $box.prop('id');
                if (connectorIdInput)
                    boxId = boxId + '-' + connectorIdInput.val();
                if (boxId)
                    return boxId;

                // build Id from box text
                const $boxTitle = $box.find('.card-title');
                const textOnly = $boxTitle
                    .clone() // clone the element
                    .children() // select all the children
                    .remove() // remove all the children
                    .end() // again go back to selected element
                    .text();

                // Remove whitespace
                elementId = textOnly.replace(/ /g, appn.emptyString);

                // Set the dynamic Id
                if (elementId)
                    $element.prop('id', elementId);
            }

        return elementId;
    }

    export function findItemInRegister(registerId: any, haystack: Array<any>) {
        if (!haystack || !registerId)
            return null;

        let itemMatch = null;

        $(haystack).each((function (i: number, item: any): boolean {
            if (item.elementId === registerId) {
                itemMatch = item;
                return false;
            }

            return true;
        } as any));

        return itemMatch;
    }

    export function createOrUpdateRegister(registerItem: any) {
        // Create or update the register
        let pageStateRegister = appn.localStorage.getItem(dbKey);
        if (!pageStateRegister)
            pageStateRegister = [registerItem]; // first time - create new register
        else {
            // register exists so go ahead and find this item by its element id in the register
            let foundMatch = false;
            $(pageStateRegister).each((function (i: number, item: any): boolean {
                if (item.elementId === registerItem.elementId) {
                    item.value = registerItem.value;
                    foundMatch = true;
                    return false;
                }

                return true;
            } as any));

            if (!foundMatch)
                pageStateRegister.push(registerItem);
        }

        // Update the register
        appn.localStorage.setItem(dbKey, pageStateRegister);
        $('table.dataTable thead tr th input[type="checkbox"]').prop('checked', false);
    }

    export function resetState(): void {
        dataTable.clearSearch();
        dataTable.resetPaging();
        clearPageStateRegister();
        dataTable.uncheckAllRowsBox();
    }

    function getElementValue($element: JQuery<HTMLInputElement>) {
        const inputType = getInputType($element);

        if (inputType === 'checkbox' || inputType === 'radio')
            return $element.prop('checked');

        if (inputType === 'select-one')
            return $element.val();

        if (inputType === 'button.card-btn-expand-or-collapse') {
            // Need to find out the current state on the box that is on the screen
            // Use the box-collapsed adminlte class that get applied to the boxes main div
            let isCurrentStateExpanded = false;
            const $parentBox = $element.closest('.card');
            if (!$parentBox.hasClass('collapsed-card'))
                isCurrentStateExpanded = true;

            return isCurrentStateExpanded ? 'expanded' : 'collapsed';
        }

        if (inputType === 'appnDateFilter')
            return appn.dateFilter.getValueAsString();

        if (inputType === 'appnDateFilterMini')
            return appn.dateFilterMini.getValueAsString();

        if (inputType === 'appnTaskTemplateFilter')
            return appn.taskTemplateFilter.getValue();

        if (inputType === 'appnFolderFilter')
            return appn.folderFilter.getValue();

        if (inputType === 'appnUserGroupFilter')
            return appn.userGroupFilter.getValue();

        return null;
    }

    function setElementValue($element: JQuery<HTMLInputElement>, value: any) {
        const inputType = getInputType($element);

        if (inputType === 'checkbox' || inputType === 'radio') {
            $element.prop('checked', value);
            return;
        }

        if (inputType === 'select-one') {
            // must check if the value exists in the select list as the items may have changed.
            const existsInSelect = valueExistsInSelect($element.attr('id'), value);

            if (!existsInSelect) {
                // Set to first item in list and update register rather than reloading page
                const valueToSet: any = $('#' + $element.attr('id') + ' option:first').val();
                $element.val(valueToSet);
                const registerItem = {
                    elementId: $element.attr('id'),
                    value: $element.val()
                };
                createOrUpdateRegister(registerItem);
                return;
            }

            $element.val(value);
            return;
        }

        if (inputType === 'button.card-btn-expand-or-collapse') {
            // Need to find out the current state on the box that is on the screen
            // Use the box-collapsed adminlte class that get applied to the boxes main div
            let isCurrentStateExpanded = false;
            const $parentBox = $element.closest('.card');
            if (!$parentBox.hasClass('collapsed-card'))
                isCurrentStateExpanded = true;

            if (value === 'expanded') {
                if (!isCurrentStateExpanded)
                    $element.click();
            } else if (isCurrentStateExpanded)
                $element.click();
            return;
        }

        if (inputType === 'appnDateFilter') {
            appn.dateFilter.setValueFromString(value);
            return;
        }

        if (inputType === 'appnDateFilterMini') {
            appn.dateFilterMini.setValueFromString(value);
            return;
        }

        if (inputType === 'appnTaskTemplateFilter') {
            if (!appn.taskTemplateFilter.listContains(value)) {
                value = appn.emptyString;
                const registerItem = {
                    elementId: $element.attr('id'),
                    value: value
                };
                createOrUpdateRegister(registerItem);
            }

            appn.taskTemplateFilter.setValue(value);
            return;
        }

        if (inputType === 'appnFolderFilter') {
            if (!appn.folderFilter.listContains(value)) {
                value = appn.emptyString;
                const registerItem = {
                    elementId: $element.attr('id'),
                    value: value
                };
                createOrUpdateRegister(registerItem);
            }

            appn.folderFilter.setValue(value);
            return;
        }

        if (inputType === 'appnUserGroupFilter') {
            if (!appn.userGroupFilter.listContains(value)) {
                value = appn.emptyString;
                const registerItem = {
                    elementId: $element.attr('id'),
                    value: value
                };
                createOrUpdateRegister(registerItem);
            }

            appn.userGroupFilter.setValue(value);
            return;
        }

        $element.val(value);
    }

    function valueExistsInSelect(elementId: any, value: any) {
        let exists = false;
        $('#' + elementId + ' option').each((function (this: any): boolean {
            if ((this as HTMLInputElement).value === value) {
                exists = true;
                return false;
            }

            return true;
        } as any));

        return exists;
    }

    function isSelectOneHasBlankValue($selectOne: JQuery<HTMLElement>): boolean {
        const emptyOption = $selectOne.find('option[value=""]');
        return emptyOption.length > 0;
    }

    function resetInput($element: JQuery<HTMLElement>) {
        const inputType = getInputType($element);

        if (inputType === 'checkbox' || inputType === 'radio') {
            $element.prop('checked', false);
            return;
        }

        if (inputType === 'select-one') {
            if (isSelectOneHasBlankValue($element))
                // Default to the option with a blank value
                $element.val(appn.emptyString);
            else
                // Default to thec first option as there are no blank value options
                $element.val($element.find('option:first').val() as string);

            return;
        }

        if (inputType === 'appnDateFilter') {
            appn.dateFilter.reset();
            return;
        }

        if (inputType === 'appnDateFilterMini') {
            appn.dateFilterMini.reset();
            return;
        }

        if (inputType === 'appnTaskTemplateFilter') {
            appn.taskTemplateFilter.reset();
            return;
        }

        if (inputType === 'appnFolderFilter') {
            appn.folderFilter.reset();
            return;
        }

        if (inputType === 'appnUserGroupFilter') {
            appn.userGroupFilter.reset();
        }
    }

    function getInputType($element: JQuery<HTMLElement>): string {
        let inputType: string = '';
        if ($element.is('input') && $element.prop('type') === 'checkbox')
            inputType = 'checkbox';

        if ($element.prop('type') === 'select-one')
            inputType = 'select-one';

        if ($element.prop('type') === 'radio')
            inputType = 'radio';

        if ($element.prop('type') === 'button')
            if ($element.hasClass('card-btn-expand-or-collapse'))
                inputType = 'button.card-btn-expand-or-collapse';
            else
                inputType = 'button';

        if ($element.hasClass('appnDateFilter'))
            inputType = 'appnDateFilter';

        if ($element.hasClass('appnDateFilterMini'))
            inputType = 'appnDateFilterMini';

        if ($element.hasClass('appnTaskTemplateFilter'))
            inputType = 'appnTaskTemplateFilter';

        if ($element.hasClass('appnFolderFilter'))
            inputType = 'appnFolderFilter';

        if ($element.hasClass('appnUserGroupFilter'))
            inputType = 'appnUserGroupFilter';

        return inputType;
    }

    function clearPageStateRegister() {
        appn.localStorage.removeItem(dbKey);
    }

    function clearPageStateRegisterItem(elementId: any) {
        const pageStateRegister = appn.localStorage.getItem(dbKey);

        if (!pageStateRegister)
            return;

        // Remove the item if its there
        let indexToRemove = -1;
        $(pageStateRegister).each((function (i: number, item: any): boolean {
            if (item.elementId === elementId) {
                indexToRemove = i;
                return false;
            }

            return true;
        } as any));

        if (indexToRemove === -1)
            return;

        // remove this item from the array
        pageStateRegister.splice(indexToRemove, 1);

        // Update the register
        appn.localStorage.setItem(dbKey, pageStateRegister);
    }
}
